const actions = {
  DEVICES_ERROR: "DEVICES_ERROR",
  GET_DEVICES_REQUEST: "GET_DEVICES_REQUEST",
  GET_DEVICES_SUCCESS: "GET_DEVICES_SUCCESS",
  GET_DEVICE_REQUEST: "GET_DEVICE_REQUEST",
  GET_DEVICE_SUCCESS: "GET_DEVICE_SUCCESS",
  GET_DEVICE_CONFIG_REQUEST: "GET_DEVICE_CONFIG_REQUEST",
  GET_DEVICE_CONFIG_SUCCESS: "GET_DEVICE_CONFIG_SUCCESS",
  DELETE_DEVICE_REQUEST: "DELETE_DEVICE_REQUEST",
  DELETE_DEVICE_SUCCESS: "DELETE_DEVICE_SUCCESS",
  UPDATE_DEVICE_REQUEST: "UPDATE_DEVICE_REQUEST",
  UPDATE_DEVICE_SUCCESS: "UPDATE_DEVICE_SUCCESS",
  UPDATE_DEVICE_CONFIG_REQUEST: "UPDATE_DEVICE_CONFIG_REQUEST",
  UPDATE_DEVICE_CONFIG_SUCCESS: "UPDATE_DEVICE_CONFIG_SUCCESS",
  CREATE_DEVICE_REQUEST: "CREATE_DEVICE_REQUEST",
  CREATE_DEVICE_SUCCESS: "CREATE_DEVICE_SUCCESS",
  REQUEST_PAIRING_REQUEST: "REQUEST_PAIRING_REQUEST",
  REQUEST_PAIRING_SUCCESS: "REQUEST_PAIRING_SUCCESS",
  SUBMIT_PAIRING_REQUEST: "SUBMIT_PAIRING_REQUEST",
  SUBMIT_PAIRING_SUCCESS: "SUBMIT_PAIRING_SUCCESS",

  getDevices: token => {
    return {
      type: actions.GET_DEVICES_REQUEST,
      token
    };
  },
  getDeviceById: (token, id) => {
    return {
      type: actions.GET_DEVICE_REQUEST,
      token,
      id
    };
  },
  getDeviceConfig: (token, id) => {
    return {
      type: actions.GET_DEVICE_CONFIG_REQUEST,
      token,
      id
    };
  },
  deleteDevice: (token, id) => {
    return {
      type: actions.DELETE_DEVICE_REQUEST,
      token,
      id
    };
  },
  updateDevice: (token, device) => {
    return {
      type: actions.UPDATE_DEVICE_REQUEST,
      token,
      device
    };
  },
  updateDeviceConfig: (token, id, configs) => {
    return {
      type: actions.UPDATE_DEVICE_CONFIG_REQUEST,
      token,
      id,
      configs
    };
  },
  createDevice: (token, device) => {
    return {
      type: actions.CREATE_DEVICE_REQUEST,
      token,
      device
    };
  },
  /**
   *
   * @param {string} token
   * @param {object} pairingObj { serialNumber, pairingCode }
   * @returns
   */
  requestPairing: (token, pairingObj) => {
    return {
      type: actions.REQUEST_PAIRING_REQUEST,
      token,
      pairingObj
    };
  },
  /**
   *
   * @param {string} token
   * @param {object} pairingObj { serialNumber, pairingCode }
   * @returns
   */
  submitPairing: (token, pairingObj) => {
    return {
      type: actions.SUBMIT_PAIRING_REQUEST,
      token,
      pairingObj
    };
  }
};

const devicesActions = actions;

export default devicesActions;
